import { useState } from 'react';
import { api } from '../services/api';

interface UploadResult {
    success: boolean;
    data?: {
        url: string;
        key: string;
    };
    error?: string;
}

export const useImageUpload = () => {
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const uploadImage = async (file: File): Promise<UploadResult> => {
        setUploading(true);
        setError(null);

        // Client-side validation
        if (!file.type.startsWith('image/')) {
            const err = '画像ファイルのみアップロード可能です。';
            setError(err);
            setUploading(false);
            return { success: false, error: err };
        }

        if (file.size > 5 * 1024 * 1024) { // 5MB limit
            const err = '5MB以下の画像を選択してください。';
            setError(err);
            setUploading(false);
            return { success: false, error: err };
        }

        try {
            const result = await api.uploadImage(file);
            if (result.success) {
                return { success: true, data: result.data };
            } else {
                setError(result.error || 'アップロードに失敗しました');
                return { success: false, error: result.error };
            }
        } catch (e: any) {
            setError(e.message || 'アップロードに失敗しました');
            return { success: false, error: e.message };
        } finally {
            setUploading(false);
        }
    };

    return { uploadImage, uploading, error };
};
